import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-257fe2ec")

_pushScopeId("data-v-257fe2ec")
const _hoisted_1 = { class: "text-area" }
const _hoisted_2 = {
  key: 0,
  class: "button-wrap"
}
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Send to: All")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Send to: " + /*#__PURE__*/_toDisplayString(' '))
const _hoisted_6 = { class: "text-wrap" }
const _hoisted_7 = { class: "text-input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (!_ctx.isMobileScreen)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "icon emotion",
                  mode: "flat",
                  size: "l",
                  icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic24-icon-emotion', color: '--sui-gray-600'},
                  "icon-only": ""
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              class: "icon attachment",
              mode: "flat",
              size: "l",
              icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-attachment-gray'},
              "icon-only": ""
            }, null, 8, ["icon"])
          ]),
          (!_ctx.isSelected)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "button",
                onClick: _ctx.sendMessage,
                mode: "flat",
                size: "l",
                icon: "ic12-arrow-down"
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "button",
                mode: "primary",
                size: "l",
                icon: { name: 'ic12-arrow-up', height: '12px', width: '12px'}
              }, {
                default: _withId(() => [
                  _hoisted_5,
                  _createVNode("span", null, _toDisplayString(_ctx.selectedUsers), 1)
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("textarea", {
          class: "message",
          name: "chat",
          placeholder: _ctx.t('chat.placeholder'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.message = $event)),
          ref: "textArea",
          onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
        }, null, 40, ["placeholder"]), [
          [_vModelText, _ctx.message]
        ])
      ]),
      _createVNode(_component_Button, {
        class: "icon send",
        onClick: _ctx.sendMessage,
        size: "l",
        mode: "flat",
        icon: _ctx.iconProps,
        "icon-only": ""
      }, null, 8, ["onClick", "icon"])
    ])
  ]))
})